import moment from 'moment';

export default function(value, format, inputFormat) {
    if ( !format ) {
        format = 'MMMM D, YYYY';
    }

    return moment(value, inputFormat).format(format);
}
